import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class warningDialog_template extends vnTemplate{

    protected parent: any;

    public getTemplateHtml(): string {

        return `
                <div class="w-lightbox light-theme" data-bind="css: { 'is-visible': isVisible }">
                        <div class="lightbox-content">
                            <div class="w-form lightbox-form" id="clear-tags">
                                <div class="form-header">
                                    <h3 class="form-title" data-bind="text: title()"></h3>
                                    <!-- ko if: showCancelBtn -->
                                    <button data-bind="event: { click: onClickCancel }" type="button" class="close-button icon i-close-2 stay-enabled"></button>
                                    <!-- /ko -->
                                </div>
                       
                                <div class="form-body">
                                     <div class="form-group">
                                        <p class="form-text" data-bind="html: message()"></p>
                                     </div>
                                 </div>
                    
                                <div class="form-footer">
                                    <!-- ko if: showCancelBtn -->
                                    <button data-bind="event: { click: onClickCancel }" class="btn stay-enabled" type="button">Cancel</button>
                                    <!-- /ko -->
                                    <button data-bind="event: { click: onClickConfirm }" class="btn highlight stay-enabled" type="button">Confirm</button>
                                </div>
                            </div>
                        </div>
                </div>`;

    }

    public setParent(parent){

        this.parent = parent;
    }

    protected initPartial(): void {

    }

    protected getTemplateName(): string{

        return "warningDialog-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return  {
            title: ko.observable("")
            ,message: ko.observable("")
            ,isVisible: ko.observable(false)
            ,showCancelBtn: ko.observable(true)
            ,onClickCancel: function (data, event) { huit_neuf_this.cancel() }
            ,onClickConfirm: function (data, event) { huit_neuf_this.confirm(); }
        };
    }

    public cancel(){

        this.caller.onClickCancelDialog(this.idElement)
        this.setIsVisible(false);
    }

    public confirm(){

        this.caller.onClickConfirmDialog(this.idElement);
        this.setIsVisible(false);
    }

    public setTitle(title){

        this.getTemplateViewModel().title(title);
    }

    public setMessage(message){

        this.getTemplateViewModel().message(message);
    }

    public setIsVisible(bool :boolean){

        this.getTemplateViewModel().isVisible(bool);
    }

    public hideCancelBtn(){
        this.getTemplateViewModel().showCancelBtn(false)
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/warningDialog_template.ts